export enum DEPOSIT_ACTIONS {
  SET_BANK_TRANSFER_INFO = 'DEPOSIT_ACTIONS.SET_BANK_TRANSFER_INFO',
  SET_BLOCKCHAIN_TRANSFER_INFO = 'DEPOSIT_ACTIONS.SET_BLOCKCHAIN_TRANSFER_INFO',
}
